import { RootState } from "../../../store";
import { AskAiInterface } from "../../utils/types";

export const askAiSliceSelector = (state: RootState): AskAiInterface =>
  state.askAi;
